import axios from '../../utils/axios';
import config from '../../utils/config';

const getVideos = async (tags, search, pageNo = 1, author = '') => {
    let queryString = '';

    if (tags?.length > 0) {
        queryString += tags.map((tag) => `tags_like=${tag}`).join('&');
    }

    if (search !== '') {
        queryString += `&q=${search}`;
    }

    if (author !== '') {
        queryString += `&author_like=${author}`;
    }

    const response = await axios.get(
        `/videos/?${queryString}&_page=${pageNo}&_limit=${config.paginationSize}`
    );

    return response.data;
};

export default getVideos;
